import {
    RichTableColumns,
} from 'app/types/richtable.types'
import {
    DeletedLogger,
} from 'app/Apps/ContainerManagement/Containers/containers.types'
import {
    NestedKeyOf,
} from 'app/types/utils.types'
import {
    LoggerConfiguration,
} from 'app/enums/label.enums'

const deletedLoggersColumns = (
    l: (key: string) => string,
): RichTableColumns<NestedKeyOf<DeletedLogger>>[] => {
    return [
        {
            id: 'logger.loggerNumber',
            headerProps: {
                children: l('LOGGER'),
            },
            mapCellProps: 'logger.loggerNumber',
            minWidth: '150px',
        },
        {
            id: 'isDefaultLogger',
            headerProps: {
                children: l('IS_DEFAULT'),
            },
            mapCellProps: 'isDefaultLogger',
            componentName: 'Boolean',
        },
        {
            id: 'loggerPositionConfiguration',
            headerProps: {
                children: l('LOGGER_CONFIGURATION'),
            },
            mapCellProps: 'loggerPositionConfiguration',
            componentName: 'EnumValue',
            allowedValuesEnum: LoggerConfiguration,
            minWidth: '150px',
        },
        {
            id: 'exchangeTimestamp',
            headerProps: {
                children: l('EXCHANGE_ON'),
            },
            mapCellProps: 'exchangeTimestamp',
            minWidth: '200px',
            componentName: 'DateTimeCell',
        },
        {
            id: 'removedOn',
            headerProps: {
                children: l('REMOVED_ON'),
            },
            mapCellProps: 'removedOn',
            minWidth: '200px',
            componentName: 'DateTimeCell',
        },
        {
            id: 'deletedBy',
            headerProps: {
                children: l('DELETED_BY'),
            },
            mapCellProps: 'deletedBy',
        },
        {
            id: 'deletedOn',
            headerProps: {
                children: l('DELETED_ON'),
            },
            mapCellProps: 'deletedOn',
            minWidth: '200px',
            componentName: 'DateTimeCell',
        },
    ]
}

export default deletedLoggersColumns
